<template>
  <v-app>
    <v-container fluid>
      <v-card elevation="2" outlined :loading="loading">
        <v-card-title>
          <!--                                    v-if="$can('transaction_create')"-->
          <v-btn
            to="/workReports/create"
            class="btn-add-with-text"
            v-status="'workReports_create'"
          >
            <v-icon>mdi-plus</v-icon>
            افزودن گزارش کار
          </v-btn>
          <v-spacer />
          گزارش کارهای شما
          <v-spacer />
          <!--          <v-btn :loading="loading" @click="getData(url)" class="btn-update">-->
          <!--            <v-icon>mdi-refresh</v-icon>-->
          <!--            به روزرسانی-->
          <!--          </v-btn>-->
        </v-card-title>
        <v-divider />
        <div class="row">
          <div class="col-md-12 p-5">
            <data-table
              orderDir="desc"
              :data="data"
              :columns="columns"
              :debounce-delay="5000"
              :translate="translates"
              :per-page="perPages"
              @on-table-props-changed="reloadTable"
            >
            </data-table>
          </div>
        </div>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Btn from "@/view/pages/categories/Btn";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  data() {
    return {
      url: "workReports",
      columns: [
        {
          label: "شناسه",
          name: "id",
          orderable: true,
          colStyle: "width: 100px;",
        },
        {
          label: "نام",
          name: "name",
          orderable: true,
          transform: (val) => {
            return val.data.user.name + "  " + val.data.user.lastName;
          },
        },

        {
          name: "company_presence",
          label: "حضوری/دورکاری",
          transform: (value) => {
            return value.data.company_presence == "present"
              ? "حضوری"
              : "دورکاری";
          },
        },

        {
          name: "start_date",
          label: "ساعت شروع",
          orderable: true,
          transform: (value) => {
            return value.data.start_date !== null
              ? this.$options.filters.longDate(value.data.start_date)
              : "نامعلوم";
          },
        },

        {
          name: "end_date",
          label: "ساعت پایان",
          orderable: true,
          transform: (value) => {
            return value.data.end_date !== null
              ? this.$options.filters.longDate(value.data.end_date)
              : "نامعلوم";
          },
        },

        {
          label: "زمان استفاده شده برای آموزش",
          name: "learning_time",
          orderable: true,
          transform: (val) => {
            return val.data.learning_time + "ساعت ";
          },
        },

        {
          label: "توضیحات",
          name: "description",
          orderable: true,
          transform: (val) => {
            return val.data.description.length > 10
              ? val.data.description.substring(0, 10) + " ..."
              : val.data.description;
          },
        },

        {
          label: "تاریخ ویرایش",
          name: "updated_at",
          transform: (val) => {
            return this.$options.filters.longDate(val.data.updated_at);
          },
        },
        // {
        //   label: 'عملیات',
        //   name: 'actions',
        //   type: 'html',
        //   component: Btn,
        //   handler: this.action,
        //   event:'action',
        //   meta: {
        //     permission_prefix: 'content_',
        //   }
        //
        // },
      ],
      loading: false,
      tableProps: {
        search: "",
        length: 10,
        column: "id",
        dir: "desc",
      },
      query: { sort: "id", order: "desc", limit: 25, s: "" },
      xprops: {
        module: "ContentIndex",
        route: "content",
        content_prefix: "content_",
        fetchIndexData: "fetchIndexData",
      },
    };
  },
  created() {
    // this.getData(this.url)
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t(this.$route.meta.title) },
    ]);
  },
  beforeDestroy() {
    this.resetState();
  },
  computed: {
    ...mapGetters(["layoutConfig"]),
    ...mapGetters("ContentIndex", ["contents", "total", "loading"]),

    config() {
      return this.layoutConfig();
    },
  },

  methods: {
    getData(url = this.url, options = this.tableProps) {
      this.loading = true;
      this.requestApiGet(this.url, options).then((response) => {
        this.data = response.data;
        this.loading = false;
      });
    },

    reloadTable(tableProps) {
      this.getData(this.url, tableProps);
    },

    action(data, type) {
      this[type](data);
    },
  },

  edit(data) {
    this.$router.push({ name: "content.edit", params: { id: data.id } });
  },
};
</script>
